export enum NavigatorsEnum {
  GOOGLE = "Google Maps",
  WAZE = "Waze",
  TWO_GIS = "2GIS",
  OSM = "OSM",
}
